import { render, staticRenderFns } from "./CreateDocumentYearEndMeeting.vue?vue&type=template&id=985c7a7a&scoped=true&"
import script from "./CreateDocumentYearEndMeeting.vue?vue&type=script&lang=js&"
export * from "./CreateDocumentYearEndMeeting.vue?vue&type=script&lang=js&"
import style0 from "./CreateDocumentYearEndMeeting.vue?vue&type=style&index=0&id=985c7a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985c7a7a",
  null
  
)

export default component.exports